import { render, staticRenderFns } from "./ModalGlobalDialog.vue?vue&type=template&id=dfe25f26&lang=pug"
import script from "./ModalGlobalDialog.vue?vue&type=script&lang=js"
export * from "./ModalGlobalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports